module.exports = __webpack_public_path__ + "/templates/components/carousel/boats-ext[static].twig";